import {
    EXCLUSION_APPLIED_NOTIFICATION,
    BAN_NOTIFICATION
} from '../constants/serviceMessage';

import {
    CURRENT_USER_BLOCKED,
    CURRENT_USER_UNBLOCKED
} from '../constants/block';

import {udiff} from '../utils';
import {ROOM_TYPE_PERSONAL} from '../constants/rooms';
import {BobTVUser} from '../components/bobtv-neo/BobTVUser/index';

function compareBlockedByExtended(a, b) {
    return a.uid === b.uid;
}

export default function blockBind(chatInterface, store) {
    /** @type {{nick, ufrag, private_data}} **/
    var _loggedInUser;

    function handleExclusionApplied(user) {
        if (user.nick === _loggedInUser.nick) {
            chatInterface.logout();
            window.location.reload();
        }
    }

    function handleBanNotification() {
        chatInterface.logout();
        window.location.reload();
    }

    function handleRoomCreatorBlacklisting() {
        chatInterface.logout();
        window.location.reload();
    }

    chatInterface.onServiceMessage(function(ServiceMessage) {
        if (ServiceMessage.type == EXCLUSION_APPLIED_NOTIFICATION) {
            handleExclusionApplied(ServiceMessage.data);
        }

        if (ServiceMessage.type == BAN_NOTIFICATION) {
            handleBanNotification(ServiceMessage.data);
        }
    });

    chatInterface.onLoginSuccess(function(user) {
        _loggedInUser = new BobTVUser(user);
    });

    chatInterface.onRoomClientUpdate(function(user) {
        let updatedUser = new BobTVUser(user);

        if (!_loggedInUser || updatedUser.ufrag !== _loggedInUser.ufrag) return false;

        let {added, removed} = udiff(_loggedInUser.blocked_by, updatedUser.blocked_by, compareBlockedByExtended);

        if (!added.length && !removed.length) return false;

        let {videoStreams, pmConversations, currentRoom} = store.getState();

        if (added.length) {
            added.map(function(blocklistEntry) {
                store.dispatch({type: CURRENT_USER_BLOCKED, uid: blocklistEntry.uid});

                if (currentRoom.type == ROOM_TYPE_PERSONAL && currentRoom.creator.uid === blocklistEntry.uid) {
                    handleRoomCreatorBlacklisting();
                }

                for (let ufrag in videoStreams) {
                    let videoStream = videoStreams[ufrag];
                    if (videoStream.user.uid == blocklistEntry.uid) {
                        chatInterface.viewUserLeaveStream(ufrag);
                        return;
                    }
                }
            });
        }

        if (removed.length) {
            removed.map(function(blocklistEntry) {
                store.dispatch({type: CURRENT_USER_UNBLOCKED, uid: blocklistEntry.uid});

                for (let ufrag in videoStreams) {
                    let videoStream = videoStreams[ufrag];
                    if (videoStream.user.uid == blocklistEntry.uid) {
                        chatInterface.sendViewRequest(ufrag);
                    }
                }

                for (let ufrag in pmConversations) {
                    let pmConversation = pmConversations[ufrag];
                    if (pmConversation.user.uid == blocklistEntry.uid) {
                        chatInterface.sendPmRequest(pmConversation.user);
                    }
                }
            });
        }

        _loggedInUser = updatedUser;
    });
}


// WEBPACK FOOTER //
// ./src/bindings/chatinterface-block.js